import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiVisa, BaseApiTemplateService, Core2Config} from '../shared';

@Injectable({
    providedIn: 'root'
})
export class EcomDeleteLoginService extends BaseApiTemplateService<any> {
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_ECOM_URL_PREFIX + 'identity/delete';
      this.endpoint_path = Core2Config.TENANT_ECOM_URL_PREFIX + 'identity/delete';
      this.httpClient = http;
    }
  
    deleteEcomLogin(login_guid:String, apiVisa: ApiVisa) {
      if (this.endpoint_path && apiVisa.api_domain_url) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/' + login_guid;
      }
      return this.httpClient.delete(this.apiUrl, this.getHttpHeader(apiVisa));
    }
}